import clsx from "clsx";
import { Modal } from "../modal";
import { Button } from "../button";
import { Typography } from "../typography";

interface ConfirmModalProps {
  text: string;
  onConfirm: () => void;
  onCancel: () => void;
  confirmText?: string;
  isOpen: boolean;
  loading?: boolean;
  title?: string;
  className?: string;
}

export const ConfirmModal = ({
  text,
  onCancel,
  onConfirm,
  confirmText,
  isOpen,
  loading,
  title,
  className,
}: ConfirmModalProps) => (
  <Modal size="xsmall" isOpen={isOpen} onClose={onCancel}>
    <div className="p-5">
      {title && (
        <Typography
          tag="h5"
          className="font-semibold text-lg md:leading-10 tracking-wide my-0"
        >
          {title}
        </Typography>
      )}
      <div className="mb-7 mt-2">
        <span
          className={clsx("text-base font-medium my-10 break-words", className)}
        >
          {text}
        </span>
      </div>
      <div className="flex items-center gap-2">
        <Button
          disabled={loading}
          fullWidth
          size="small"
          onClick={onCancel}
          color="blackOutlined"
        >
          Cancel
        </Button>
        <Button fullWidth size="small" loading={loading} onClick={onConfirm}>
          {confirmText || "Confirm"}
        </Button>
      </div>
    </div>
  </Modal>
);
